import { lazy } from 'react';

export const Aggregation = lazy(() => import('./Aggregation'));
